import React, { createContext, useContext } from 'react';
import useAwsUrlHook from '../../../hooks/Dashboard/aws/useUrl';

export const AwsUrlContext = createContext();

export const AwsUrlProvider = ({ children }) => {
  const data = useAwsUrlHook(); // Import everything from the hook

  return (
    <AwsUrlContext.Provider value={data}>
      {children}
    </AwsUrlContext.Provider>
  );
};

export const useAwsUrl = () => useContext(AwsUrlContext);